import { normalizeUrlSlashes, resolveAssetUrl } from './resolveAssetUrl';

/**
 * Display URL for account images. API may return `pan_image`, `pan_image_url`, or both.
 * @param {object | null | undefined} account
 * @param {string} baseKey e.g. `pan_image`, `employee_image`, `aadhar_front_image`
 */
export function accountImageDisplayUrl(account, baseKey) {
  if (!account || !baseKey) return '';
  const urlKey = `${baseKey}_url`;
  for (const key of [urlKey, baseKey]) {
    const val = account[key];
    const resolved = resolveAssetUrl(val);
    if (resolved) return resolved;
    if (typeof val === 'string' && val.trim()) return normalizeUrlSlashes(val.trim());
  }
  return '';
}

export function accountHasImage(account, baseKey) {
  return Boolean(accountImageDisplayUrl(account, baseKey));
}
